import styled from 'styled-components'
import tw from 'twin.macro'

export const ImageAndTextWithLinksWrap = styled.div`
  ${tw`w-full py-8`}
`

export const ImageAndTextWithLinkItem = styled.div`
  ${tw`flex flex-col h-full pt-4 pb-10`}
`

export const ImageWrap = styled.div`
  ${tw`w-full mb-4`}

  > img {
    ${tw`w-full h-auto object-cover`}
    height: 250px;
  }
`

export const Text = styled.h3`
  ${tw`text-lg font-semibold text-white mb-4`}
`
